import { useCallback, useState } from "react";

const isNotificationOptionsObject = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return false;
  }

  return (
    Object.prototype.hasOwnProperty.call(value, "controller") ||
    Object.prototype.hasOwnProperty.call(value, "actionLabel") ||
    Object.prototype.hasOwnProperty.call(value, "actionUrl") ||
    Object.prototype.hasOwnProperty.call(value, "onAction") ||
    Object.prototype.hasOwnProperty.call(value, "id") ||
    Object.prototype.hasOwnProperty.call(value, "duration")
  );
};

export const useNotification = () => {
  const [notifications, setNotifications] = useState([]);

  const removeNotification = useCallback((id) => {
    setNotifications((prevNotifications) =>
      prevNotifications.filter((notification) => notification.id !== id)
    );
  }, []);

  const addNotification = useCallback(
    (
      message,
      type,
      controllerOrOptions = null, // new AbortController() or options object
      id = Date.now()
    ) => {
      let controller = controllerOrOptions;
      let actionLabel = "";
      let actionUrl = "";
      let onAction = null;
      let notificationId = id;
      let duration = 60000;

      if (isNotificationOptionsObject(controllerOrOptions)) {
        controller = controllerOrOptions.controller || null;
        actionLabel = String(controllerOrOptions.actionLabel || "");
        actionUrl = String(controllerOrOptions.actionUrl || "");
        onAction =
          typeof controllerOrOptions.onAction === "function"
            ? controllerOrOptions.onAction
            : null;
        notificationId =
          controllerOrOptions.id !== undefined
            ? controllerOrOptions.id
            : notificationId;
        duration =
          typeof controllerOrOptions.duration === "number"
            ? controllerOrOptions.duration
            : duration;
      }

      setNotifications((prevNotifications) => [
        ...prevNotifications,
        {
          id: notificationId,
          message,
          type,
          controller,
          actionLabel,
          actionUrl,
          onAction,
        },
      ]);

      if (duration > 0) {
        setTimeout(() => {
          removeNotification(notificationId);
        }, duration);
      }
    },
    [removeNotification]
  );

  return {
    notifications,
    addNotification,
    removeNotification,
  };
};
